import React from "react"
import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { tonalPalettes } from '@zuto/theme/src/mui/Colors'

interface BannerProps {
    bannerText: string
}

const BannerContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  backgroundColor: tonalPalettes.primary[40],
  color: tonalPalettes.primary[100],
  paddingTop: theme.spacing(5),
  paddingBottom: theme.spacing(5)
}))

export const Banner = ({ bannerText }: BannerProps) => {
    return (
        <BannerContainer>
            <Typography variant="titleLarge" component="h1" sx={{ mb: 0 }}>{bannerText}</Typography>
        </BannerContainer>
    )
}
